import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
//import { Network } from '@ionic-native/network/ngx';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
export enum ConnectionStatus { Online, Offline }
import { PluginListenerHandle } from '@capacitor/core';
@Injectable({
  providedIn: 'root'
})

export class NetworkService {
  networkListener: any;
  public status: ConnectionStatus;
  private _status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(null);

  constructor() {
    this.status = navigator.onLine ? ConnectionStatus.Online : ConnectionStatus.Offline;
    this.setStatus(this.status);
    this.initializeNetworkEvents();
  }

  public initializeNetworkEvents(): void {

    if (Capacitor.platform === 'web') {

      window.addEventListener('online', () => {
        this.setStatus(ConnectionStatus.Online);
      });

      window.addEventListener('offline', () => {
        this.setStatus(ConnectionStatus.Offline);
      });

    } else {
      if (this.networkListener) {
        this.networkListener.remove();
      }

      this.networkListener = Network.addListener('networkStatusChange', status => {
      //  alert(status.connected);
        if(status.connected){
          this.setStatus(ConnectionStatus.Online);
        }else{
          this.setStatus(ConnectionStatus.Offline);
        }
        console.log('Network status changed', status);
      });

      // this.network.onDisconnect().subscribe(() => {
      //   this.setStatus(ConnectionStatus.Offline);
      // })

      // this.network.onConnect().subscribe(() => {
      //   this.setStatus(ConnectionStatus.Online);
      // })
    }
  }

 async getNetworkType() {
    return await Network.getStatus();//this.network.type
  }

  public getNetworkStatus(): Observable<ConnectionStatus> {
    return this._status.asObservable();
  }

  endNetworkListener() {
    if (this.networkListener && Capacitor.platform !== 'web') {
    //  alert("end")
      this.networkListener.remove();
    }
  }

  private setStatus(status: ConnectionStatus) {
    this.status = status;
    this._status.next(this.status);
  }

}
